import { LocalStorage } from "./LocalStorage";
import { StorageManager } from "./StorageManager";
class PlaceOrderRequestSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(raw) {
        try {
            return JSON.parse(raw);
        }
        catch {
            return null;
        }
    }
}
export class LastCheckoutRequestStorageManager {
    constructor() { }
    static getInstance() {
        if (LastCheckoutRequestStorageManager.instance === undefined) {
            LastCheckoutRequestStorageManager.instance = new StorageManager({
                storage: LocalStorage.create(),
                storageKey: "client_lastCheckoutRequest",
                storageSerializer: new PlaceOrderRequestSerializer(),
            });
        }
        return LastCheckoutRequestStorageManager.instance;
    }
    static store(request) {
        LastCheckoutRequestStorageManager.getInstance().store(request);
    }
    static restore() {
        return LastCheckoutRequestStorageManager.getInstance().restore();
    }
    static erase() {
        LastCheckoutRequestStorageManager.getInstance().erase();
    }
}
